import React from 'react';
import {motion} from 'framer-motion';
import {PieChart,Pie,Cell,ResponsiveContainer,Legend,Tooltip} from 'recharts';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiUsers,FiAward,FiTrendingUp}=FiIcons;

const ProfessionalAudience=()=> {
  const audienceData=[
    {
      name: 'Qualified Actuaries',
      value: 51,
      color: '#00BCD4',
      description: 'Actuaries with significant post-qualification experience & newly qualified actuaries'
    },
    {
      name: 'Part-Qualified Actuaries',
      value: 22,
      color: '#009343',
      description: 'Advanced professionals & early career trainees'
    },
    {
      name: 'Actuarial Students',
      value: 18,
      color: '#FF6B35',
      description: 'Future decision-makers'
    },
    {
      name: 'Other',
      value: 9,
      color: '#8E44AD',
      description: 'Various backgrounds'
    }
  ];

  const CustomTooltip=({active,payload})=> {
    if (active && payload && payload.length) {
      const data=payload[0].payload;
      return (
        <div className="glass-effect rounded-lg p-3 border border-white/20">
          <p className="text-white font-semibold">{data.name}</p>
          <p className="text-proactuary-blue-200">{data.value}% - {data.description}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <motion.div
      className="glass-effect rounded-2xl p-8"
      initial={{opacity: 0,y: 20}}
      animate={{opacity: 1,y: 0}}
      transition={{duration: 0.6}}
    >
      <div className="text-center mb-8">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center"
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          transition={{delay: 0.2}}
        >
          <SafeIcon icon={FiUsers} className="text-proactuary-green-400 mr-3" />
          Premium Professional Audience
        </motion.h2>
        <div className="w-24 h-1 bg-gradient-to-r from-proactuary-green-500 to-proactuary-blue-500 mx-auto rounded-full" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <motion.div
          className="h-96"
          initial={{opacity: 0,scale: 0.8}}
          animate={{opacity: 1,scale: 1}}
          transition={{delay: 0.3}}
        >
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={audienceData}
                cx="50%"
                cy="50%"
                labelLine={false}
                outerRadius={120}
                fill="#8884d8"
                dataKey="value"
                animationBegin={0}
                animationDuration={1500}
              >
                {audienceData.map((entry,index)=> (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
              <Legend 
                wrapperStyle={{color: 'white'}}
                formatter={(value,entry)=> `${value} (${entry.payload.value}%)`}
              />
            </PieChart>
          </ResponsiveContainer>
        </motion.div>

        <div className="space-y-4">
          {audienceData.map((item,index)=> (
            <motion.div
              key={index}
              className="glass-effect rounded-xl p-4 border border-white/10 hover:border-white/30 transition-colors"
              initial={{opacity: 0,x: 20}}
              animate={{opacity: 1,x: 0}}
              transition={{delay: 0.4 + index * 0.1}}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div 
                    className="w-4 h-4 rounded-full" 
                    style={{backgroundColor: item.color}}
                  />
                  <div>
                    <div className="text-white font-semibold">{item.name}</div>
                    <div className="text-white/70 text-sm">{item.description}</div>
                  </div>
                </div>
                <div className="text-2xl font-bold text-white">{item.value}%</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      <motion.div
        className="bg-gradient-to-r from-proactuary-green-500/20 to-proactuary-blue-500/20 rounded-xl p-6 mt-8 border border-proactuary-green-500/30"
        initial={{opacity: 0,scale: 0.95}}
        animate={{opacity: 1,scale: 1}}
        transition={{delay: 0.6}}
      >
        <h3 className="text-xl font-bold text-white mb-3 flex items-center">
          <SafeIcon icon={FiAward} className="text-proactuary-green-400 mr-2" />
          Quality Indicator
        </h3>
        <p className="text-white/90 leading-relaxed">
          <span className="font-bold text-proactuary-green-300">73% of attendees</span> are qualified or part-qualified actuaries - a core target market for AI solutions and services. Plus 18% actuarial students representing future decision-makers.
        </p>
      </motion.div>
    </motion.div>
  );
};

export default ProfessionalAudience;